import { Component, Input, OnInit } from '@angular/core';
import { ConsumptionInterface } from '../../models/consumption.interface';
import { ConstsHelper } from '../../../../helpers/consts.helper';
import { select, Store } from '@ngrx/store';
import { ConsumptionInterfaceState } from '../../store/state/consumption.state';
import { LineInterface } from '../../models/line.interface';
import { environment } from '../../../../../environments/environment';
import { ExtranetService } from '../../../shared/services/extranet.service';
import moment from 'moment';
import { PriceFormatService } from '../../../shared/services/price-format.service';

@Component({
  selector: 'app-consumption',
  templateUrl: './consumption.component.html',
  styleUrls: ['./consumption.component.css'],
  standalone: false
})
export class ConsumptionComponent implements OnInit {

  @Input()
  selectedLine: LineInterface;

  environment = environment;
  consumption: ConsumptionInterface = null;
  detailsVisibility: boolean = true;
  detailsButtonText: string = 'Voir le détail';
  displaySupportInformation: boolean;
  brand?: string;

  constructor(
      private store: Store<any>,
      private extranetService: ExtranetService,
      public priceFormatService: PriceFormatService,
  ) {}

  ngOnInit() {
    this.store.pipe(select(ConstsHelper.REDUCER_CONSUMPTION)).subscribe((response: ConsumptionInterfaceState) => {
      if (false === (response.consumption instanceof Array) && null !== response.consumption) {
        this.consumption = response.consumption;
      }
    });

    this.brand = environment.data.brand;
    this.displaySupportInformation = false;
    if (this.extranetService.getSupportUser()) {
      this.displaySupportInformation = true;
    }
  }

  displayDetails() {
    this.detailsVisibility = !this.detailsVisibility;
    if (this.detailsVisibility) {
      this.detailsButtonText = 'Voir le détail';
    } else {
      this.detailsButtonText = 'Masquer le détail';
    }
  }

  getDate(consumption: ConsumptionInterface, selectedLine: LineInterface, index: number) {
    const activationSimDate = selectedLine.billStartDate.split('-');
    if (selectedLine.statusDetails.status === 'waiting_port' && index === 1) {
      return activationSimDate[2] + '/' + activationSimDate[1] + '/' + activationSimDate[0];
    } else if (selectedLine.statusDetails.status === 'waiting_port' && index === 2) {
      return consumption.date;
    }

    let startDate = consumption.date;
    const splitDate = consumption.date.split('/');
    if (this.brand === 'prixtel') {
      if (splitDate.length > 0 && splitDate[0] !== '01') {
        if (parseInt(activationSimDate[1], 10) === parseInt(splitDate[1], 10) && parseInt(activationSimDate[2], 10) === parseInt(splitDate[2], 10)) {
          startDate = activationSimDate[2] + '/' + activationSimDate[1] + '/' + activationSimDate[0];
        } else {
          startDate = '01/' + splitDate[1] + '/' + splitDate[2];
        }
      }
    } else {
      let billingCycleDay = selectedLine.billingCycleDay < 10 ? '0' + selectedLine.billingCycleDay : selectedLine.billingCycleDay.toString();
      const lastDayByMonth = [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];
      if (parseInt(splitDate[0], 10) >= selectedLine.billingCycleDay) {
        if (parseInt(billingCycleDay) > lastDayByMonth[parseInt(splitDate[1]) - 1]) {
          billingCycleDay = lastDayByMonth[parseInt(splitDate[1])].toString();
        }
        startDate = billingCycleDay + '/' + splitDate[1] + '/' + splitDate[2];
      } else {
        const start = moment(consumption.date, 'DD/MM/YYYY').subtract(1, 'months').format('MM/YYYY');
        if (parseInt(billingCycleDay) > lastDayByMonth[parseInt(moment(start, 'MM/YYYY').format('MM')) - 1]) {
          billingCycleDay = lastDayByMonth[parseInt(moment(start, 'MM/YYYY').format('MM')) - 1].toString();
        }
        startDate = billingCycleDay + '/' + start;
      }
    }
    return startDate;
  }

  getCounters() {
    const counters = [];
    if (this.consumption.counters instanceof Array) {
      for (const counter of this.consumption.counters) {
        if (['', null].indexOf(counter.value) === -1 && counter.label !== '') {
          counters.push(counter);
        }
      }
    }
    return counters;
  }

  getIconCard(label: string) {
    if (label.toLowerCase().includes('sms')) {
      return 'icons/' + this.brand + '_consumption_sms.png';
    } else if (label.toLowerCase().includes('data')) {
      return 'icons/' + this.brand + '_consumption_data.png';
    } else if (label.toLowerCase().includes('voix')) {
      return 'icons/' + this.brand + '_consumption_voice.png';
    } else if (label.toLowerCase().includes('wallet')) {
      return 'icons/wallet.png';
    } else {
      return 'icons/' + this.brand + '_consumption_sms.png';
    }
  }
}
